module.exports = __webpack_public_path__ + "static/media/banner2.77454ff8.png";